export function validatePriceGroups(inputData) {
  return {
    valid: true,
    errors: []
  }
}
